import { Injectable } from "@angular/core";
import { fromEvent, Observable, shareReplay, startWith, map } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root",
})
export class DeviceService {
  public isBelow(width: number): Observable<boolean> {
    const mql = window.matchMedia(`(max-width: ${width}px)`);
    return fromEvent<MediaQueryListEvent>(mql, "change").pipe(
      map((e) => e.matches),
      startWith(mql.matches),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  public isBelowSignal(width: number) {
    return toSignal(this.isBelow(width), { initialValue: false });
  }
}
